/**
 * LoggingProxy class defines the proxy of logging instrumentation.
 * Prototype definition comes from 'legacy-js/common/instrumentation/log'.
 * They need to be implemented if we want to replace logging tool.
 */
export default class LoggingProxy {
  /**
   * Initialize logging tool with given value.
   * @param {object} logging - The logging tool passed from init function.
   */
  constructor(logging) {
    this.logging = logging;
  }

  trace(methodName, message, scenarioName) {
    return this.logging.trace(methodName, message, scenarioName);
  }

  error(methodName, message, scenarioName) {
    return this.logging.error(methodName, message, scenarioName);
  }

  verbose(methodName, message, scenarioName) {
    return this.logging.verbose(methodName, message, scenarioName);
  }

  perf(metric, value, scenarioName) {
    return this.logging.perf(metric, value, scenarioName);
  }

  startScenario(scenarioName, message) {
    return this.logging.startScenario(scenarioName, message);
  }

  endScenario(scenarioName, result, message) {
    return this.logging.endScenario(scenarioName, result, message);
  }

  pageRouteStart(pagePath, viewName, previousPath, previousView) {
    return this.logging.pageRouteStart ? this.logging.pageRouteStart(pagePath, viewName, previousPath, previousView) : null;
  }

  pageRoutePageLoadDuration(pagePath, loadDuration, isRecorded) {
    return this.logging.pageRoutePageLoadDuration ? /* istanbul ignore next */ this.logging.pageRoutePageLoadDuration(pagePath, loadDuration, isRecorded) : null;
  }

  pageRouteEnd(pagePath, viewName, activityId, stayDuration, nextPagePath, isUnload) {
    return this.logging.pageRouteEnd ? this.logging.pageRouteEnd(pagePath, viewName, activityId, stayDuration, nextPagePath, isUnload) : null;
  }

  flushLogs(callback) {
    return this.logging.flushLogs(callback);
  }

  logError(methodName, message) {
    return this.logging.logError(methodName, message);
  }
}
